<template>
	<!-- eslint-disable vue/no-v-html -->
	<q-layout-header class="no-shadow">
		<div class="row justify-center">
			<div style="width: 1140px; max-width: 90vw">
				<div id="header" class="row justify-center q-mb-lg">
					<div id="header-image" class="col-xs-12 col-sm-6 col-md-6 col-xl-6 right text-right">
						<img src="/images/cockpit/playlist-header.svg" alt="Playlist" />
					</div>
					<div id="header-text" class="col-xs-12 col-sm-6 col-md-6 col-xl-6 self-center">
						<div class="q-body-1" style="font-size: 16px; line-height: 1.5" v-html="description"></div>
					</div>
				</div>
			</div>
		</div>
	</q-layout-header>
</template>

<script>
	export default {
		name: 'GuestPlaylistHeader',
		props: {
			description: {
				type: String,
				default: ''
			}
		}
	};
</script>
